<script setup lang="ts">
interface Props {
  as?: string;
  ratingAverage?: number;
  reviews?: number;
}

const { ratingAverage = 0, reviews = 0, as = 'span' } = defineProps<Props>()

const runtimeConfig = useRuntimeConfig()

const minReviewCount = computed(() => runtimeConfig.public.minReviewCount)
const hasReviews = computed(() => reviews >= minReviewCount.value)
</script>

<template>
  <component :is="as" v-if="hasReviews" class="flex items-center">
    <IconRating :rating="ratingAverage" class="text-18 lg:text-24" />
    <span class="text-12 ml-2">
      ({{ reviews }})
    </span>
  </component>
</template>
